import keyBy from 'lodash-es/keyBy'
import mapValues from 'lodash-es/mapValues'

import { DOC_FLOW_OPEN_STATUSES } from '../../../../constants/docFlow'
import {
  FILTER_NAME_SUB_MENU,
  STATUS_FILTER_NAME,
} from '../../../../constants/filter'
import { SUBMENU_PARAM_ACTIVE_VALUE } from '../../../../constants/route'
import { toText } from '../../../../utils/html'
import { getUserAvatar, getUserFullName } from '../../../../utils/user'
import {
  BIRDVIEW_PREVIEW_SEPARATOR,
  BIRDVIEW_TILE_DELTA_TONE,
} from '../../DashboardBirdview.constants'
import { BirdviewKpiUnit } from '../../DashboardBirdview.constants.charts'
import { toBirdviewTileDelta } from '../../DashboardBirdview.utils.charts'
import { checkIsBirdviewChatCommunication } from '../../DashboardBirdview.utils.targets'

function getBirdviewCommunicationSnippet({ kind, snippet }) {
  return snippet && checkIsBirdviewChatCommunication(kind)
    ? toText(snippet)
    : snippet
}

export function getBirdviewDocFlowsFilters() {
  return {
    [FILTER_NAME_SUB_MENU]: SUBMENU_PARAM_ACTIVE_VALUE,
    [STATUS_FILTER_NAME]: DOC_FLOW_OPEN_STATUSES,
  }
}

export function toBirdviewDocFlowItem(docFlow) {
  return {
    id: docFlow.id,
    phase: docFlow.phase,
    status: docFlow.status,
    title: docFlow.name,
  }
}

export function toBirdviewCommunicationItem(row) {
  return {
    date: row.waiting_since,
    id: row.id,
    kind: row.kind,
    messageId: row.message_uuid,
    subtitle: [
      row.sender?.name || row.sender?.email,
      getBirdviewCommunicationSnippet(row),
    ]
      .filter(Boolean)
      .join(BIRDVIEW_PREVIEW_SEPARATOR),
    title: row.title,
    unread: row.is_unread,
  }
}

export function toBirdviewPortfolioItem(building) {
  return {
    id: building.id,
    open: building.open,
    overdue: building.overdue,
    title: building.title,
  }
}

export function toBirdviewTeamLoadItem(member) {
  return {
    avatarProps: getUserAvatar(member),
    id: member.id,
    open: member.open,
    overdue: member.overdue,
    title: getUserFullName(member),
  }
}

// The backend sends the weekly `delta` for the Admin team scope only.
export function toBirdviewSummaryTiles(tiles) {
  return mapValues(keyBy(tiles, 'key'), tile => ({
    count: tile.count,
    delta: toBirdviewTileDelta({
      delta: tile.delta,
      unit: BirdviewKpiUnit.Percent,
    }),
    deltaTone: BIRDVIEW_TILE_DELTA_TONE[tile.delta_tone],
  }))
}
